import { render, staticRenderFns } from "./big-screen.vue?vue&type=template&id=bc330eb2&scoped=true&"
import script from "./big-screen.vue?vue&type=script&lang=js&"
export * from "./big-screen.vue?vue&type=script&lang=js&"
import style0 from "./big-screen.vue?vue&type=style&index=0&id=bc330eb2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc330eb2",
  null
  
)

export default component.exports